import { memo } from 'react';

const ErrorMessage = ({ message, isHtml = false }) => (
	<>
		{message && !isHtml && (
			<div className="mx-1 mt-2 text-[0.875rem] text-oly-red-default">
				{message}
			</div>
		)}
		{message && isHtml && (
			<div className="mx-1 mt-2 text-[0.875rem] text-oly-red-default" dangerouslySetInnerHTML={{ __html: message }} />
		)}
	</>
);

export default memo(ErrorMessage);
